import React from 'react';

import ConsumableShow from '@components/shared/consumables/ConsumableShow';
import { useLoaderData } from 'react-router-dom';

export default function OperatorConsumableShow() {
  const consumable = useLoaderData();

  return (
    <ConsumableShow
      consumable={consumable}
      role="operator"
    />
  );
}
